module.exports = __webpack_public_path__ + "assets/img/examend.831295f6.png";